<!--
댓글 등록완료 결과화면
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">댓글이 등록되었습니다</h4>
            </div>

            <div class="uk-modal-body uk-padding-small " >
                <div class="guide">
                    할당을 지정하지 않으면, 질문내용을 확인 할 수 없습니다.<br />
                    <span class="highlight">반드시 할당을 [창고] 또는 [한국총괄]로 지정해 주세요</span><br /><br />

                    사진요청 및 도착상품에 대한 문의는 [창고]로 선택해 주시고,<br />
                    그 밖의 문의는 [한국총괄]을 선택해 주세요
                </div>

            </div>


            <div class="uk-modal-footer uk-text-center">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-black"
                    v-on:click="refreshPage"
                >
                    <span uk-icon="icon: check"></span>
                    확인
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data: function () {
            return {

            };
        },
        computed: {
        },
        methods: {
            /**
             * 결과화면 출력
             */
            show() {
                UIkit.modal(this.$el).show();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .guide {
        text-align: center;

        .highlight {
            font-size: 1.25rem;
            color: #1e87f0;
        }
    }
</style>